/**
 * PD Bracelet Click Fix
 * Bracelet swatch tıklayınca sol taraftaki ürün resminin değişmesini sağlar.
 *
 * Sorun: Orijinal pdHandleBraceletClick, Dawn native radio sync başarılı
 * olduğunda updateProductImage çağırmıyordu. Hidden picker_types ile
 * Dawn kendi image switch'ini yapmadığı için resim değişmiyordu.
 *
 * Çözüm: Color handler (pdHandleClick) ile aynı pattern — her zaman
 * URL, cart form ve resim güncelle, Dawn sync'e güvenme.
 */
(function() {
  'use strict';

  function getVariantData() {
    var el = document.getElementById('pd-variant-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch(e) { return []; }
  }

  function updateCartFormId(variantId) {
    if (!variantId) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      var input = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
      if (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateProductImage(variantId, variantData) {
    var variant = null;
    for (var i = 0; i < variantData.length; i++) {
      if (String(variantData[i].id) === String(variantId)) { variant = variantData[i]; break; }
    }
    if (!variant) return;

    var mid = variant.media_id || variant.image_id;
    if (!mid) return;

    var mg = document.querySelector('media-gallery');
    if (!mg || typeof mg.setActiveMedia !== 'function') return;

    var sectionId = mg.dataset.section || '';
    var fullId = sectionId ? sectionId + '-' + mid : String(mid);
    var item = mg.querySelector('[data-media-id="' + fullId + '"]');
    if (!item) item = mg.querySelector('[data-media-id$="-' + mid + '"]');
    if (item) mg.setActiveMedia(item.dataset.mediaId, true);
  }

  window.pdHandleBraceletClick = function(el) {
    var wrapper = document.getElementById('pd-product-swatch-wrapper');
    var braceletWrapper = el.closest('.pd-bracelet-wrapper');
    if (!braceletWrapper) return;

    // 1. UI: active state
    var items = el.parentElement.querySelectorAll('.pd-bracelet-item');
    for (var i = 0; i < items.length; i++) items[i].classList.remove('active');
    el.classList.add('active');

    var val = el.getAttribute('data-value');

    // 2. Label
    var label = document.getElementById('pd-bracelet-selected-val');
    if (label) label.textContent = val;

    var optionName = braceletWrapper.getAttribute('data-option-name') || '';
    var pos = braceletWrapper.getAttribute('data-option-position') || '2';

    // 3. Variant bul (seçili renk + bracelet)
    var variantData = getVariantData();
    var selectedColor = '';
    if (wrapper) {
      var activeColor = wrapper.querySelector('.pd-fp-item.active');
      if (activeColor) selectedColor = activeColor.getAttribute('data-value');
    }

    var matchedVariant = null;
    var optKey = 'option' + pos;
    for (var i = 0; i < variantData.length; i++) {
      var v = variantData[i];
      if (v[optKey] === val && (!selectedColor || v.option1 === selectedColor)) {
        matchedVariant = v;
        break;
      }
    }

    // 4. URL guncelle
    if (matchedVariant) {
      window.history.replaceState(null, '', window.location.pathname + '?variant=' + matchedVariant.id);
    }

    // 5. Dawn native radio sync (fiyat/availability guncellemesi icin)
    var section = (wrapper && wrapper.closest('product-info'))
      || (wrapper && wrapper.closest('[id^="shopify-section-"]'))
      || document;

    var radios = section.querySelectorAll('.product-form__input input[type="radio"]');
    radios.forEach(function(radio) {
      if (radio.value === val && radio.name === optionName) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 6. Cart form + resim guncelle (HER ZAMAN, Dawn sync olsa da olmasa da)
    if (matchedVariant) {
      updateCartFormId(matchedVariant.id);
      setTimeout(function() {
        updateProductImage(matchedVariant.id, variantData);
      }, 150);
    }
  };

  /* ==========================================================
     COLOR CHANGE → BRACELET RESET
     Color swatch tıklandığında updateBraceletSwatches() bracelet'i
     sadece gizlendiğinde reset eder. Ama yeni renkte de aynı bracelet
     mevcutsa (örn: Oyster), active kalır — büyük resimle uyumsuz olur.
     Çözüm: Color değişiminden sonra bracelet'i her zaman birinciye
     (= color swatch'ın data-variant-id'sine eşleşen) reset et.
     ========================================================== */
  document.addEventListener('click', function(e) {
    var colorItem = e.target.closest('.pd-fp-item');
    if (!colorItem) return;

    // updateBraceletSwatches 200ms'de çalışır, ondan sonra reset yap
    setTimeout(function() {
      var bw = document.getElementById('pd-bracelet-swatch-wrapper');
      if (!bw) return;

      var firstVisible = bw.querySelector('.pd-bracelet-item:not([style*="display: none"])');
      if (!firstVisible) return;

      var currentActive = bw.querySelector('.pd-bracelet-item.active');
      if (currentActive === firstVisible) return; // zaten doğru

      // Tüm active'leri kaldır, ilkini seç
      bw.querySelectorAll('.pd-bracelet-item.active').forEach(function(item) {
        item.classList.remove('active');
      });
      firstVisible.classList.add('active');

      // Label güncelle
      var label = document.getElementById('pd-bracelet-selected-val');
      if (label) label.textContent = firstVisible.getAttribute('data-value');

      // Variant sync (URL, cart form, native radio, resim)
      if (typeof window.pdHandleBraceletClick === 'function') {
        window.pdHandleBraceletClick(firstVisible);
      }
    }, 300);
  }, true);
})();
